import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_2 = {
  class: "itemcard downloadcard",
  style: {"padding":"0"}
}
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { style: {"margin":"30px"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "downloadbtn",
  style: {"padding-bottom":"50px"}
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Read more")
], -1)




export default /*#__PURE__*/_defineComponent({
  props: {
  card: Object,
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: props.card.link
      }, [
        _createElementVNode("img", {
          src: props.card.img,
          alt: "",
          style: {"width":"100%","max-height":"unset","min-width":"unset"}
        }, null, 8, _hoisted_4),
        _createElementVNode("h3", _hoisted_5, _toDisplayString(props.card.title), 1),
        _hoisted_6
      ], 8, _hoisted_3)
    ])
  ]))
}
}

})